export default {
  HERO: "hero",
  SPOTLIGHT: "spotlight",
  SHELF: "shelf",
  HEADER: "header",
  NAV: "nav",
  FOOTER: "footer",
  SHARE: "share",
  DIRECT: "direct",
};
